<div class="block-group-title">
    <h2 class="title" [innerHtml]="lotAffectation.display.title[getSizeAsString()] | translate | safe:'html'"></h2>
    <p *ngIf="lotAffectation.display.subTitle" class="sub-title"><span
        [innerHtml]="lotAffectation.display.subTitle[getSizeAsString()] | translate | safe:'html'"></span></p>

    <!--<p class="notice">glisSer-déposer <br>pour affecter <br>vos comptes </p>-->
</div>
